module.exports = __webpack_public_path__ + "static/media/transfer_horiz_24px_blue.7c426dc4.svg";